import { MedicalInsurancePlan } from '../../models/Entities/MedicalInsurances/MedicalInsurancePlan';
import { CommonState } from '../common/state/commonState';

export interface MedicalInsurancePlanState
  extends CommonState<MedicalInsurancePlan> {}

export const MedicalInsurancePlansUnloadState: any = {
  // loading all
  isLoadingAll: false,
  isLoadingAllSuccess: undefined,
  FailGettingAll: false,

  // loading one
  isLoadingOne: false,
  isLoadingOneSuccess: undefined,
  FailGettingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  FailSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  FailAdding: false,

  isFiltered: false,
  filterCriteria: undefined,

  list: [],
  Selected: undefined,
  Error: undefined
};
